function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "switch/on",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 533",
    width: 40,
    height: 20,
    rx: 10,
    transform: "translate(0 4)",
    style: {
      fill: "#efddd5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3236",
    transform: "translate(-531 -2223)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 117",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(551 2223)",
    style: {
      fill: "#f26524"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1237",
    d: "M12.014 4.419v-12l8 6z",
    transform: "translate(549.986 2238.581)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOn);
export default __webpack_public_path__ + "static/media/switchOn.b70ba5e2.svg";
export { ForwardRef as ReactComponent };